import { a } from './chunk-IMSWER4T.js';

var o=(t=>(t.RETAILER="Retailer",t.SUPPLIER="Supplier",t.ADMIN="Admin",t))(o||{});var r=class{_client=a.instance;async getClientTypes(){return (await this._client.get("/workspace-types")).data}};

export { o as a, r as b };
//# sourceMappingURL=chunk-ORP5YLZI.js.map
//# sourceMappingURL=chunk-ORP5YLZI.js.map